import es from '../es';
import { dashboardEs } from '../dashboard';
import { godOnboardingEs } from '../godOnboarding';
import { integrityEs } from '../integrity';
import { helpChatExtraEs } from '../helpChatExtra';
import { knowledgeUiEs } from '../knowledgeUi';
import { auditUiEs } from '../auditUi';
import { legalUiEs } from '../legalUi';
import { pageChromeEs } from '../pageChrome';
import { staffEarningsEs } from '../staffEarnings';
import { runnerRouteEs } from '../runnerRoute';
import { mvpCleanupEs } from '../mvpCleanup';
import { billingEs } from '../billing';

/** Full Spanish dictionary (code-split chunk). */
const esLocale = {
  ...es,
  ...dashboardEs,
  ...godOnboardingEs,
  ...integrityEs,
  ...helpChatExtraEs,
  ...knowledgeUiEs,
  ...auditUiEs,
  ...legalUiEs,
  ...pageChromeEs,
  ...staffEarningsEs,
  ...runnerRouteEs,
  ...mvpCleanupEs,
  ...billingEs,
};

export default esLocale;
